import script from "./Slider.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=7d5fc0be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5fc0be"]])

export default __exports__